import { render, staticRenderFns } from "./CookieCard.vue?vue&type=template&id=8192490a&scoped=true&lang=html"
import script from "./CookieCard.vue?vue&type=script&lang=js"
export * from "./CookieCard.vue?vue&type=script&lang=js"
import style0 from "./CookieCard.vue?vue&type=style&index=0&id=8192490a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8192490a",
  null
  
)

export default component.exports